import '../../../src/docReady.js';
import Vimeo from '@vimeo/player';

import isMobile from '../../../src/isMobile.js';
import Easie from '../../../src/Easie.js'; // easing
import Helper from '../../../src/Helper.js'; // easing

// import Swiper bundle with all modules installed
import Swiper, {Pagination, Navigation} from 'swiper';
// import 'swiper/css/bundle';

import './style.scss';

const moduleSelector = '.eiovisual-cover';

/**
 * Classe esempio
 */
class Module {

    // _________________________________________________________________________

    constructor() {
        this.run();

        Helper.debug('Modulo cover');
    }

    // _________________________________________________________________________

    live(element, selector) {

        // Initialize results with current nodes.
        var result = Array.prototype.slice.call(element.querySelectorAll(selector));

        // Create observer instance.
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                [].forEach.call(mutation.addedNodes, function (node) {
                    if (node.nodeType === Node.ELEMENT_NODE && node.matches(selector)) {
                        result.push(node);
                    }
                });
            });
        });

        // Set up observer.
        observer.observe(element, { childList: true, subtree: true });

        return result;
    }

    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {

    constructor($module) {
        var that = this;

        this.$module = $module;

        this.init_carousel($module);
    }

    // _________________________________________________________________________

    /**
     * Restituisce il dominio da un url
     * @param {type} url
     * @returns {nm$_module.module.exports.get_domain_by_url.domain|nm$_module.exports.get_domain_by_url.domain}
     */
    get_domain_by_url(url) {
        // ricava il player presente nel frame
        var domain = url.replace('http://', '').replace('https://', '').split(/[/?#]/)[0];

        return domain;
    }

    // _________________________________________________________________________

    /**
     * Inizializza il player in una slide
     * @param {type} $slide
     * @returns {undefined}
     */
    init_player($slide) {
        // Per ogni slide, verifica se ci sono player a cui collegare azioni di pausa dello slider nel caso di play

        // ottiene l'iframe
        var $iframe = $slide.querySelector('iframe');

        console.log($iframe);

        if ($iframe !== null) {
            var url = $iframe.getAttribute('src');
            var domain = this.get_domain_by_url(url);
        }

        /**
         * Azioni differenti nel caso di video player
         * @param {type} message
         * @returns {undefined}
         */
        if (domain !== undefined) {
            switch (domain) {
                case 'player.vimeo.com':
                    this.init_player_vimeo($iframe);
                    break;
            }
        }
    }

    // _________________________________________________________________________

    /**
     * Inizializza il player Vimeo
     * @param {type} $iframe
     * @returns {undefined}
     */
    init_player_vimeo($iframe) {
        // azioni nel caso di player vimeo
        var player = new Vimeo($iframe);

        this.config_player_vimeo(player);
    }

    // _________________________________________________________________________

    /**
     * Gestisce gli eventi del player Vimeo
     * @param {type} player
     * @returns {undefined}
     */
    config_player_vimeo(player) {
        var that = this;

        that.$module.addEventListener('slideChange',() => {
            player.pause();
        })

        // Quando il video viene riprodotto
        // - lo slider va in pausa
        /*
        player.on('play', function () {
            that.Slider.pause();
        });
        */

        // Quando il video viene riprodotto
        //  - lo slider riparte
        /*
        player.on('pause', function () {
            that.Slider.resume();
        });
        */
    }

    // _________________________________________________________________________

    /**
     * Avvia il carousel
     * @param {type} $module
     * @returns {undefined}
     */
    init_carousel($module) {

        var that = this;

        // _______________

        this.$slides = $module.querySelectorAll('.swiper-slide');

        this.$slides.forEach(($slide) => {
            this.init_player($slide);
        });

        // _______________

        var $swiper = $module.querySelector('.swiper');

        // init Swiper:
        const swiper = new Swiper($swiper, {
            // configure Swiper to use modules
            modules: [Navigation, Pagination],

            loop: true,

            // If we need pagination
            /*
            pagination: {
              el: '.swiper-pagination',
            },
            */
          
            // Navigation arrows
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
          
            // And if we need scrollbar
            /*
            scrollbar: {
              el: '.swiper-scrollbar',
            },
            */
            
        });

        swiper.on('slideChange',() => {
            const event = new Event('slideChange');
            that.$module.dispatchEvent(event);

            // pause all videos
            const $video_s = that.$module.querySelectorAll('video');
            $video_s.forEach(function ($video) {
                $video.pause();
            })
        })

    }

    // _________________________________________________________________________

    /**
     * Inizializza counter
     * @returns {undefined}
     */
    init_counter() {
        this.$counter = this.$slideshow.parentNode.querySelector('.simple-slider-counter .current-index');
    }

    // _________________________________________________________________________
}

// export
export default new Module();